import React, { useState, useEffect, useRef, useContext } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Card, Col, Row, FormGroup, Label, Button, Form } from "reactstrap";
import axios from "axios";
import base_url from "../api/bootapi";
import { toast } from "react-toastify";
import moment from "moment";
import NavbarNew from "../Navbar/NavbarNew";
import { useForm, Controller, set } from "react-hook-form";
import { Backdrop, CircularProgress } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { CountryDropdown, RegionDropdown } from "react-country-region-selector";
import { LeadContext } from "../ContextAPI/LeadContext";
import Swal from "sweetalert2"

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: 1000,
    color: "#fff",
  },
}));

const swalWithBootstrapButtons = Swal.mixin({
  customClass: {
    confirmButton: "btn btn-success",
    cancelButton: "btn btn-danger",
  },
  buttonsStyling: false,
});

const CreateClientLead = () => {
  const classes = useStyles();
  const navigate = useNavigate();
  const { clientId } = useParams();
  const [backdropopen, setbackdropOpen] = useState(false);

  const clientdetails = JSON.parse(localStorage.getItem("isw_client_details_frontend"));
  const user_name = clientdetails?.name || "Admin";
  const user_email = clientdetails?.username || "admin@isw.com";
  const { leadsData } = useContext(LeadContext);

  // --- Dropdown Data States ---
  const [allOffices, setAllOffices] = useState([]);
  const [clientSources, setClientSources] = useState([]);
  const [allVisaTypes, setAllVisaTypes] = useState([]);
  const [allInsuranceProviders, setAllInsuranceProviders] = useState([]);
  const [allInsuranceTypes, setAllInsuranceTypes] = useState([]);
  const [allServices, setAllServices] = useState([]);
  const [tempClientData, setTempClientData] = useState(null);
  const { register, handleSubmit, control, formState: { errors }, setValue, reset, watch , getValues} = useForm();
  const [allSuperAgents, setAllSuperAgents] = useState([]); 
  const [allIntakes, setAllIntakes] = useState([]); 

  const selectedBranch = watch("officeId");
  const watchCountry = watch("country");

  useEffect(() => {
    if (!clientdetails?.token) navigate("/login");

    
    fetchInitialData();

    leadsData.map((lead) => {
      if (lead.id == clientId) {
        const formatForInput = (dateStr) => dateStr ? moment(dateStr).format("YYYY-MM-DD") : "";

        setValue("email", lead.email || lead.assigneeEmail || "");
        setValue("firstName", lead.firstName || "");
        setValue("middleName", lead.middleName || "");
        setValue("lastName", lead.lastName || "");
        setValue("gender", lead.gender || "");
        setValue("alias", lead.alias || "");
        setValue("dob", formatForInput(lead.dateOfBirth));

        setValue("address", lead.address || "");
        setValue("city", lead.city || "");
        setValue("country", lead.country || "");
        setValue("state", lead.state || "");
        setValue("pincode", lead.pincode || "");

        setValue("phone", lead.phone || "");
        setValue("secondaryPhone", lead.secondaryPhone || "");
        setValue("secondaryEmail", lead.secondaryEmail || "");

        setValue("officeId", lead.officeId || "");
        setValue("consultantId", lead.assigneeId || ""); 
        setValue("leadType", lead.leadType || "HotLead");
        setValue("interestedServices", lead.interestedServices || "");
        setValue("clientSource", lead.clientSource || "");

        setValue("passportNumber", lead.passportNumber || "");
        setValue("passportCountry", lead.passportCountry || "");
        setValue("passportIssueDate", formatForInput(lead.passportIssueDate));
        setValue("passportExpiryDate", formatForInput(lead.passportExpiryDate));

        setValue("visaType", lead.visaType || "");
        setValue("visaIssueDate", formatForInput(lead.visaIssueDate));
        setValue("visaExpiryDate", formatForInput(lead.visaExpiryDate));

        setValue("insuranceProvider", lead.insuranceProvider || "");
        setValue("insuranceType", lead.insuranceType || "");
        setValue("policyNumber", lead.policyNumber || "");
        setValue("insuranceIssueDate", formatForInput(lead.insuranceIssueDate));
        setValue("insuranceExpiryDate", formatForInput(lead.insuranceExpiryDate));

        setValue("superAgentId", lead.superAgentId || "");
        setValue("usi", lead.usi || "");
        setValue("membershipNumber", lead.membershipNumber || "");
        setValue("membershipExpiry", formatForInput(lead.membershipExpiry));
        setValue("leadType", lead.leadType || "HotLead"); 
        setValue("comment", lead.comments || "");
        setValue("currentlyStudyingInstitutionName", lead.currentlyStudyingInstitutionName || "");
        setValue("intake", formatForInput(lead.intake));
        setValue("status", lead.status !== null ? lead.status : 1);
        
        setValue("clientRelativeName", lead.clientRelativeName || "");
        setValue("clientRelation", lead.clientRelation || "");
        setValue("clientRelativeEmail", lead.clientRelativeEmail || "");
        setValue("clientRelativePhone", lead.clientRelativePhone || "");

        setTempClientData(lead);
      }
    });
  }, []);


  const fetchInitialData = async () => {
    setbackdropOpen(true);
    try {
      await Promise.all([
        getOffices(),
        getClientSources(),
        getVisaTypes(),
        getInsuranceProviders(),
        getInsuranceTypes(),
        getInterestedServices(),
        getSuperAgents(),
        getIntakes(),
      ]);
    } catch (error) {
      console.error("Error loading data:", error);
    } finally {
      setbackdropOpen(false);
    }
  };

  const getOffices = () => axios.get(`${base_url.api5}/findAllOffice`, { headers: { Authorization: `Bearer ${clientdetails?.token}` } }).then(res => setAllOffices(res.data.data || []));
  const getClientSources = () => axios.get(`${base_url.api5}/getAllClientSourceUsingQuery`, { headers: { Authorization: `Bearer ${clientdetails?.token}` } }).then(res => setClientSources(res.data.data || []));
  const getVisaTypes = () => axios.get(`${base_url.api5}/getAllVisaType`, { headers: { Authorization: `Bearer ${clientdetails?.token}` } }).then(res => setAllVisaTypes(res.data.data || []));
  const getInsuranceProviders = () => axios.get(`${base_url.api5}/findAllInsurance`, { headers: { Authorization: `Bearer ${clientdetails?.token}` } }).then(res => setAllInsuranceProviders(res.data.data || []));
  const getInsuranceTypes = () => axios.get(`${base_url.api5}/getAllHealthCoverType`, { headers: { Authorization: `Bearer ${clientdetails?.token}` } }).then(res => setAllInsuranceTypes(res.data.data || [])).catch(e => console.warn("Health types not found"));
  const getInterestedServices = () => axios.get(`${base_url.api5}/findAllInterestedServices`, { headers: { Authorization: `Bearer ${clientdetails?.token}` } }).then(res => setAllServices(res.data.data || [])).catch(e => console.warn("Services not found"));

  const getSuperAgents = () => axios.get(`${base_url.api5}/findAgentsForDropDownList`, { headers: { Authorization: `Bearer ${clientdetails?.token}`, agentType: "Super Agent" } }).then(res => setAllSuperAgents(res.data.data || [])).catch(e => console.warn("Super Agents not found"));
  const getIntakes = () => axios.get(`${base_url.api5}/getAllIntake`, { headers: { Authorization: `Bearer ${clientdetails?.token}` } }).then(res => setAllIntakes(res.data.data || [])).catch(e => console.warn("Intakes not found"));



  const getLeadData = async (id) => {
    try {
      const res = await axios.get(`${base_url.api5}/getAllClientTempWithNewPage`, {
        headers: { Authorization: `Bearer ${clientdetails?.token}`, clientTempId: id }
      });
      const data = res.data.data;
      setTempClientData(data);
    } catch (err) {
      toast.error("Failed to fetch lead details");
    }
  };


 const handleUpdateClient = (originalPayload, existingClientId) => {
    setbackdropOpen(true);
    
    let updatePayload = JSON.parse(JSON.stringify(originalPayload));
    
    let clientDetailForUpdate = updatePayload.clientDetail || {};
    clientDetailForUpdate.id = Number(existingClientId);
    updatePayload.clientDetail = clientDetailForUpdate;
    
      updatePayload.id = Number(existingClientId);
    updatePayload.id = existingClientId; 
    
    delete updatePayload.leadId;

    const data = getValues(); 

    const headers = { 
      Authorization: `Bearer ${clientdetails?.token}`,

      enquiryLeadType: data.leadType || "Converted" 
    };
    console.log("UPDATE PAYLOAD:", updatePayload);

    axios.post(`${base_url.api5}/updateClientByUsernameNew`,  updatePayload , { headers })
      .then(res => {
        setbackdropOpen(false);
        toast.success("Client information updated successfully!");
        
        setTimeout(() => {
          navigate("/leads_list");
        }, 1500);
      })
      .catch(err => {
        setbackdropOpen(false);
        console.error("API Update Error Payload:", JSON.stringify(updatePayload, null, 2));
        toast.error(err.response?.data?.message || "Update failed. Please try again.");
      });
  };
  const onSubmit = (data) => {
    

    setbackdropOpen(true);
    const datenow = new Date().toISOString().split(".")[0];
    const adminConsultantId = clientdetails?.clientId || 0; // Uses admin's ID
const adminConsultantName = clientdetails?.name || "Admin";
const adminConsultantEmail = clientdetails?.username || "admin@isw.com";

    const formatForAPI = (dateStr) => dateStr ? moment(dateStr).format("YYYY-MM-DDTHH:mm:ss") : null;

    const selectedOfficeObj = allOffices.find(o => o.officeId.toString() == data.officeId);
    const selectedSuperAgentObj = allSuperAgents.find(a => a.id.toString() == data.superAgentId);

    const clientDetailPayload = {
      addedOn: datenow,
      address: tempClientData.address || data.address, 
      alias: tempClientData.alias || null,
      ban: 0,
      city: tempClientData.city || data.city,
      clientSource: data.clientSource || tempClientData.clientSource || null,
      comment: data.comment || tempClientData?.comments || null,
      comment: tempClientData?.comments || null,
      company: null,
      contactPreference: "Email", 
      country: tempClientData.country || data.country,
      currentlyStudyingInstitutionName: tempClientData.currentlyStudyingInstitutionName || null,
      dob: formatForAPI(tempClientData.dateOfBirth || data.dob), 
      email: tempClientData.email,
      firstName: tempClientData.firstName,
      gender: tempClientData.gender || data.gender,
      id: 0, 
      insuranceExpiryDate: formatForAPI(tempClientData.insuranceExpiryDate || data.insuranceExpiryDate),
      insuranceIssueDate: formatForAPI(tempClientData.insuranceIssueDate || data.insuranceIssueDate),
      insuranceProvider: tempClientData.insuranceProvider || data.insuranceProvider || null,
      insuranceType: tempClientData.insuranceType || data.insuranceType || null,
      comment: data.comment || tempClientData?.comments || null,
      intake: tempClientData?.intake || null,
      lastName: tempClientData.lastName, 
      membershipExpiry: formatForAPI(tempClientData.membershipExpiry || data.membershipExpiry),
      membershipNumber: (tempClientData.membershipNumber || data.membershipNumber) ? Number(tempClientData.membershipNumber || data.membershipNumber) : 0,
      middleName: tempClientData.middleName || null,
      nationality: tempClientData.country || data.country,
      passport: tempClientData.passportCountry || data.passportCountry || null,
      passportExpiryDate: formatForAPI(tempClientData.passportExpiryDate || data.passportExpiryDate),
      passportIssueDate: formatForAPI(tempClientData.passportIssueDate || data.passportIssueDate),
      passportNumber: tempClientData.passportNumber || data.passportNumber || null,
      phone: tempClientData.phone ? Number(tempClientData.phone) : 0, 
      photo: tempClientData.photo || null,
      pincode: tempClientData.pincode || data.pincode,
      policyNumber: tempClientData.policyNumber || data.policyNumber || null,
      secondaryEmail: tempClientData.secondaryEmail || data.secondaryEmail || null,
      state: tempClientData.state || data.state,
      status: Number(data.status),
      street: tempClientData.address || data.address, 
      username: tempClientData.email, 
      usi: tempClientData.usi || data.usi || null,
      visaExpiry: formatForAPI(tempClientData.visaExpiryDate || data.visaExpiryDate),
      visaIssueDate: formatForAPI(tempClientData.visaIssueDate || data.visaIssueDate),
      visaType: tempClientData.visaType || data.visaType || null,
      clientRelativeName: data.clientRelativeName || null,
      clientRelation: data.clientRelation || null,
      clientRelativeEmail: data.clientRelativeEmail || null,
      clientRelativePhone: data.clientRelativePhone ? Number(data.clientRelativePhone) : null,
      superAgentId: selectedSuperAgentObj?.id ? Number(selectedSuperAgentObj.id) : null,
      superAgentName: selectedSuperAgentObj?.name || null,
    };

    const payload = {
      id: 0, 
      leadId: clientId, 
      
      firstName: tempClientData.firstName,
      lastName: tempClientData.lastName,
      middleName: tempClientData.middleName || null,
      email: tempClientData.email,
      username: tempClientData.email,
      password: null, 
      
      address: tempClientData.address || data.address,
      city: tempClientData.city || data.city,
      state: tempClientData.state || data.state,
      country: tempClientData.country || data.country,
      pincode: tempClientData.pincode || data.pincode,
      
      secondaryEmail: tempClientData.secondaryEmail || data.secondaryEmail || null,
      
      officeId: selectedOfficeObj?.officeId ? Number(selectedOfficeObj.officeId) : 0,
      officeName: selectedOfficeObj?.officeName || null,
      officeCode: selectedOfficeObj?.officeCode || null,
     consultantId: Number(adminConsultantId),
consultantName: adminConsultantName,
consultantEmail: adminConsultantEmail,

      addedOn: datenow,
      updatedOn: datenow,
      createdBy: `${user_name} (${user_email})`,
      clientSource: data.clientSource || tempClientData.clientSource || null, 
      status: Number(data.status), 
      roleId: 8, 
      ban: 0,
      
      emailVerificationStatus: tempClientData?.emailVerificationStatus || null,
      insuranceExpiryDate: formatForAPI(tempClientData.insuranceExpiryDate || data.insuranceExpiryDate),
      insuranceIssueDate: formatForAPI(tempClientData.insuranceIssueDate || data.insuranceIssueDate),
      insuranceProvider: tempClientData.insuranceProvider || data.insuranceProvider || null,
      insuranceType: tempClientData.insuranceType || data.insuranceType || null,
      policyNumber: tempClientData.policyNumber || data.policyNumber || null,
      visaExpiry: formatForAPI(tempClientData.visaExpiryDate || data.visaExpiryDate),
      visaIssueDate: formatForAPI(tempClientData.visaIssueDate || data.visaIssueDate),
      visaType: tempClientData.visaType || data.visaType || null,

      comment: data.comment || tempClientData?.comments || null,
      currentlyStudyingInstitutionName: data.currentlyStudyingInstitutionName || tempClientData.currentlyStudyingInstitutionName || null,
      intake: formatForAPI(data.intake || tempClientData.intake),
      clientRelativeName: data.clientRelativeName || null,
      clientRelation: data.clientRelation || null,
      clientRelativeEmail: data.clientRelativeEmail || null,
      clientRelativePhone: data.clientRelativePhone ? Number(data.clientRelativePhone) : null,
      superAgentId: selectedSuperAgentObj?.id ? Number(selectedSuperAgentObj.id) : null,
      superAgentName: selectedSuperAgentObj?.name || null,

      clientDetail: clientDetailPayload
    };

    const clientDetail = {
    addedOn: datenow,
    alias: tempClientData.alias || "",
    ban: 0,
    clientSource: data.clientSource || tempClientData.clientSource || "",
    comment: data.comment || tempClientData?.comments || "",
    company: tempClientData.company || "string",
    contactPreference: "Email",
    country: tempClientData.country || data.country,
    currentlyStudyingInstitutionName: tempClientData.currentlyStudyingInstitutionName || "",
    dob: formatForAPI(tempClientData.dateOfBirth || data.dob),
    email: tempClientData.email,
    firstName: tempClientData.firstName,
    gender: tempClientData.gender || data.gender || "",
    insuranceExpiryDate: formatForAPI(tempClientData.insuranceExpiryDate || data.insuranceExpiryDate),
    insuranceIssueDate: formatForAPI(tempClientData.insuranceIssueDate || data.insuranceIssueDate),
    insuranceProvider: tempClientData.insuranceProvider || data.insuranceProvider || "",
    insuranceType: tempClientData.insuranceType || data.insuranceType || "",
    intake: tempClientData.intake || null,
    lastName: tempClientData.lastName,
    membershipExpiry: formatForAPI(tempClientData.membershipExpiry || data.membershipExpiry),
    membershipNumber: tempClientData.membershipNumber ? Number(tempClientData.membershipNumber) : 0,
    middleName: tempClientData.middleName || "",
    nationality: tempClientData.country || data.country,
    passport: tempClientData.passportCountry || data.passportCountry || null,
    passportExpiryDate: formatForAPI(tempClientData.passportExpiryDate || data.passportExpiryDate),
    passportIssueDate: formatForAPI(tempClientData.passportIssueDate || data.passportIssueDate),
    passportNumber: tempClientData.passportNumber || data.passportNumber || "",
    phone: tempClientData.phone || "",
    secondaryphone: tempClientData.secondaryPhone || "0",
    photo: tempClientData.photo || "string",
    policyNumber: tempClientData.policyNumber || data.policyNumber || "",
    secondaryEmail: tempClientData.secondaryEmail || data.secondaryEmail || "",
    status: Number(data.status),
    subAgent: null,
    superAgent: "",
    username: tempClientData.email,
    usi: tempClientData.usi || data.usi || "",
    visaExpiry: formatForAPI(tempClientData.visaExpiryDate || data.visaExpiryDate),
    visaIssueDate: formatForAPI(tempClientData.visaIssueDate || data.visaIssueDate),
    visaType: tempClientData.visaType || data.visaType || "",
    subAgentName: null,
    superAgentName: selectedSuperAgentObj?.name || null,
    subAgentId: null,
    superAgentId: selectedSuperAgentObj?.id || null,

    id: tempClientData.id || 0,

    address: tempClientData.address || data.address,
    city: tempClientData.city || data.city,
    pincode: tempClientData.pincode || data.pincode,
    state: tempClientData.state || data.state,
    street: tempClientData.address || data.address
  };

  const finalPayload = {
    address: tempClientData.address || data.address,
    city: tempClientData.city || data.city,
    clientDetail: clientDetail,

    clientSource: data.clientSource || tempClientData.clientSource || null,

   consultantId: Number(adminConsultantId),
consultantName: adminConsultantName,
consultantEmail: adminConsultantEmail,

    officeId: selectedOfficeObj?.officeId || null,
    officeName: selectedOfficeObj?.officeName || null,
    officeCode: selectedOfficeObj?.officeCode || null,

    addedOfficeCode: selectedOfficeObj?.officeCode || null,
    addedOfficeId: selectedOfficeObj?.officeId || null,
    addedOfficeName: selectedOfficeObj?.officeName || null,

    pincode: tempClientData.pincode || data.pincode,
    state: tempClientData.state || data.state,

    updatedOn: datenow,
    username: tempClientData.email
  };

   // console.log("OUTGOING PAYLOAD:", JSON.stringify(payload, null, 2));
    axios.post(`${base_url.api5}/createNewClient`, payload, {
      headers: { 
        Authorization: `Bearer ${clientdetails?.token}`,
        enquiryLeadType: data.leadType || "Converted" 
      }
    })
     .then(res => {
        setbackdropOpen(false);
        


       
        if (res.data.status_code === 200 || res.data.success) {
            
            const responseData = res.data.data || res.data; 
            
            const duplicateMessage = (responseData.Message || responseData.message || "").toLowerCase();
            const isDuplicate = responseData.isDuplicate === 1 || duplicateMessage.includes("already exists");

            if (isDuplicate) {
                const existingClientId = responseData.ClientId || responseData.id || responseData.clientId; 

                swalWithBootstrapButtons.fire({
                  title: 'Client Email Already exists?',
                  text: "Would you like to update information for this client!",
                  icon: 'warning',
                  showCancelButton: true,
                  confirmButtonText: 'Yes, update it!',
                  cancelButtonText: 'Cancel',
                }).then((result) => {
                  if (result.isConfirmed) {
                    if (!existingClientId) {
                       toast.error("Could not find existing client ID to update. Please check backend response.");
                       console.error("Error response did not contain an ID:", res.data);
                       return;
                    }
                    handleUpdateClient(finalPayload, existingClientId);
                    
                  } else if (result.dismiss === Swal.DismissReason.cancel) {
                  }
                });

            } else {
                toast.success("Lead successfully converted to Client!");
                setTimeout(() => {
                  navigate("/leads_list");
                }, 1500); 
            }

        } else {
          toast.warn(res.data.message || "Client created with potential issues.");
          setTimeout(() => {
            navigate("/leads_list");
          }, 1500);
        }
      })
      .catch(err => {
        setbackdropOpen(false);
        
        const errorMsg = (err.response?.data?.message || "").toLowerCase();
        
        if (errorMsg.includes("already exists")) { 
          
          const existingClientId = err.response?.data?.data?.id || err.response?.data?.clientId || err.response?.data?.data?.ClientId;

          swalWithBootstrapButtons.fire({
            title: 'Client Email Already exists?',
            // ...
          }).then((result) => {
            if (result.isConfirmed) {
              if (!existingClientId) {
                 toast.error("Could not find existing client ID to update.");
                 return;
              }
              handleUpdateClient(finalPayload, existingClientId);
            }
          });
          
        } else {
          console.error("API Error Payload:", JSON.stringify(finalPayload, null, 2)); 
          toast.error(err.response?.data?.message || "Conversion failed. Please try again.");
        }
      });
  };
  return (
    <div>
      <Backdrop className={classes.backdrop} open={backdropopen}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <NavbarNew />

      <div style={{ maxWidth: "1400px", margin: "0 auto", paddingTop: "110px", paddingBottom: "50px", paddingLeft: "15px", paddingRight: "15px" }}>
        <Card className="p-4 shadow-sm" style={{border: 'none'}}>
          <div className="d-flex justify-content-between align-items-center mb-4">
            <h3 style={{ color: "#224289", fontWeight: "bold" }}>Convert Lead to Client</h3>
            <Button color="secondary" outline onClick={() => navigate("/leads_list")}>
              Back to List
            </Button>
          </div>

          <Form onSubmit={handleSubmit(onSubmit)}>

             {/* === OFFICE USE === */}
             <h5 className="mb-3 mt-2" style={{ color: '#224289', borderBottom: '1px solid #e9ebf2', paddingBottom: '10px' }}>Office Use</h5>
             <Row style={{backgroundColor: '#f8f9fa', padding: '20px', borderRadius: '8px', marginBottom: '25px'}}>
                 <Col md={3}>
                     <FormGroup>
                         <Label>Branch <span className="text-danger">*</span></Label>
                         <select className={`form-control ${errors.officeId ? 'is-invalid' : ''}`} {...register("officeId", { required: true })}>
                             <option value="">- Select Branch -</option>
                             {allOffices.map(o => <option key={o.officeId} value={o.officeId}>{o.officeName}</option>)}
                         </select>
                         {errors.officeId && <small className="text-danger">Branch is required</small>}
                     </FormGroup>
                 </Col>
                 <Col md={3}>
                <FormGroup>
                    <Label>Source</Label>
                    <select className="form-control" {...register("clientSource")}>
                        <option value="">- Select Source -</option>
                        {clientSources.map(s => <option key={s.id} value={s.name}>{s.name}</option>)}
                    </select>
                </FormGroup>
            </Col>
                 <Col md={3}>
                     <FormGroup>
                         <Label>Lead Type <span className="text-danger">*</span></Label>
                         <select className={`form-control ${errors.leadType ? 'is-invalid' : ''}`} {...register("leadType", { required: true })}>
                             <option value="">- Select -</option>
                             <option value="HotLead">Hot Lead</option>
                             <option value="WarmLead">Warm Lead</option>
                             <option value="ColdLead">Cold Lead</option>
                             <option value="Converted">Converted Lead</option>
                         </select>
                         {errors.leadType && <small className="text-danger">Lead Type is required</small>}
                     </FormGroup>
                 </Col>
                  <Col md={3}>
                     <FormGroup>
                         <Label>Interested Service <span className="text-danger">*</span></Label>
                         <select className={`form-control ${errors.interestedServices ? 'is-invalid' : ''}`} {...register("interestedServices", { required: true })}>
                             <option value="">- Select Service -</option>
                             {allServices.map(s => <option key={s.id} value={s.name}>{s.name}</option>)}
                         </select>
                         {errors.interestedServices && <small className="text-danger">Service is required</small>}
                     </FormGroup>
                 </Col>
                
             </Row>

             {/* === PERSONAL DETAILS === */}
             <h5 className="mb-3 mt-4 section-header" style={{ color: '#224289', borderBottom: '1px solid #e9ebf2', paddingBottom: '10px' }}>Personal Details</h5>
             <Row>
                 <Col md={4}>
                     <FormGroup>
                         <Label>First Name <span className="text-danger">*</span></Label>
                         <input className={`form-control ${errors.firstName ? 'is-invalid' : ''}`} type="text" {...register("firstName", { required: true })} />
                         {errors.firstName && <small className="text-danger">First Name is required</small>}
                     </FormGroup>
                 </Col>
                 <Col md={4}>
                     <FormGroup>
                         <Label>Middle Name</Label>
                         <input className="form-control" type="text" {...register("middleName")} />
                     </FormGroup>
                 </Col>
                 <Col md={4}>
                     <FormGroup>
                         <Label>Last Name <span className="text-danger">*</span></Label>
                         <input className={`form-control ${errors.lastName ? 'is-invalid' : ''}`} type="text" {...register("lastName", { required: true })} />
                         {errors.lastName && <small className="text-danger">Last Name is required</small>}
                     </FormGroup>
                 </Col>
                 <Col md={4}>
                     <FormGroup>
                         <Label>Gender <span className="text-danger">*</span></Label>
                         <select className={`form-control ${errors.gender ? 'is-invalid' : ''}`} {...register("gender", { required: true })}>
                             <option value="">- Select -</option>
                             <option value="Male">Male</option>
                             <option value="Female">Female</option>
                             <option value="Other">Other</option>
                         </select>
                         {errors.gender && <small className="text-danger">Gender is required</small>}
                     </FormGroup>
                 </Col>
                 <Col md={4}>
                     <FormGroup>
                         <Label>Date of Birth</Label>
                         <input type="date" className="form-control" {...register("dob")} max={moment().format("YYYY-MM-DD")} />
                     </FormGroup>
                 </Col>
                 <Col md={4}>
                     <FormGroup>
                         <Label>Alias</Label>
                         <input className="form-control" type="text" {...register("alias")} />
                     </FormGroup>
                 </Col>
             </Row>

            {/* === CONTACT DETAILS === */}
            <h5 className="mb-3 mt-4 section-header" style={{ color: '#224289', borderBottom: '1px solid #e9ebf2', paddingBottom: '10px' }}>Contact Details</h5>
            <Row>
              <Col md={6}>
                <FormGroup>
                  <Label>Email <span className="text-danger">*</span></Label>
                  <input className={`form-control ${errors.email ? 'is-invalid' : ''}`} type="email" {...register("email", { required: true })} />
                  {errors.email && <small className="text-danger">Email is required</small>}
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup>
                  <Label>Secondary Email</Label>
                  <input className="form-control" type="email" {...register("secondaryEmail")} />
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup>
                  <Label>Phone (Primary) <span className="text-danger">*</span></Label>
                  <input className={`form-control ${errors.phone ? 'is-invalid' : ''}`} type="number" {...register("phone", { required: true })} />
                  {errors.phone && <small className="text-danger">Phone is required</small>}
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup>
                  <Label>Phone (Secondary)</Label>
                  <input className="form-control" type="number" {...register("secondaryPhone")} />
                </FormGroup>
              </Col>
            </Row>

            {/* === ADDRESS === */}
            <h5 className="mb-3 mt-4 section-header" style={{ color: '#224289', borderBottom: '1px solid #e9ebf2', paddingBottom: '10px' }}>Address</h5>
            <Row>
              <Col md={6}>
                <FormGroup>
                  <Label>Street Address <span className="text-danger">*</span></Label>
                  <input className={`form-control ${errors.address ? 'is-invalid' : ''}`} type="text" {...register("address", { required: true })} />
                  {errors.address && <small className="text-danger">Address is required</small>}
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup>
                  <Label>City/Suburb <span className="text-danger">*</span></Label>
                  <input className={`form-control ${errors.city ? 'is-invalid' : ''}`} type="text" {...register("city", { required: true })} />
                  {errors.city && <small className="text-danger">City is required</small>}
                </FormGroup>
              </Col>
              <Col md={4}>
                <FormGroup>
                  <Label>Country <span className="text-danger">*</span></Label>
                  <Controller
                    control={control}
                    name="country"
                    rules={{ required: true }}
                    render={({ field }) => (
                      <>
                        <CountryDropdown
                          className={`form-control ${errors.country ? 'is-invalid-custom' : ''}`}
                          value={field.value}
                          onChange={(val) => field.onChange(val)}
                        />
                        {errors.country && <small className="text-danger">Country is required</small>}
                      </>
                    )}
                  />
                </FormGroup>
              </Col>
              <Col md={4}>
                <FormGroup>
                  <Label>State/Region <span className="text-danger">*</span></Label>
                  <Controller
                    control={control}
                    name="state"
                    rules={{ required: true }}
                    render={({ field }) => (
                      <>
                      <RegionDropdown
                        className={`form-control ${errors.state ? 'is-invalid-custom' : ''}`}
                        country={watchCountry}
                        value={field.value}
                        onChange={(val) => field.onChange(val)}
                      />
                      {errors.state && <small className="text-danger">State is required</small>}
                      </>
                    )}
                  />
                </FormGroup>
              </Col>
              <Col md={4}>
                <FormGroup>
                  <Label>Postcode <span className="text-danger">*</span></Label>
                  <input className={`form-control ${errors.pincode ? 'is-invalid' : ''}`} type="text" {...register("pincode", { required: true })} />
                  {errors.pincode && <small className="text-danger">Postcode is required</small>}
                </FormGroup>
              </Col>
            </Row>

            {/* === PASSPORT / VISA INFORMATION === */}
            <h5 className="mb-3 mt-4 section-header" style={{ color: '#224289', borderBottom: '1px solid #e9ebf2', paddingBottom: '10px' }}>Passport / Visa Information</h5>
            <Row>
               <Col md={3}>
                  <FormGroup>
                      <Label>Passport Number</Label>
                      <input className="form-control" type="text" {...register("passportNumber")} />
                  </FormGroup>
               </Col>
               <Col md={3}>
                   <FormGroup>
                       <Label>Passport Country</Label>
                       <Controller
                           control={control}
                           name="passportCountry"
                           render={({ field }) => (
                               <CountryDropdown className="form-control" value={field.value} onChange={(val) => field.onChange(val)} />
                           )}
                       />
                   </FormGroup>
               </Col>
               <Col md={3}>
                  <FormGroup>
                      <Label>Passport Issue Date</Label>
                      <input type="date" className="form-control" {...register("passportIssueDate")} max={moment().format("YYYY-MM-DD")} />
                  </FormGroup>
               </Col>
               <Col md={3}>
                  <FormGroup>
                      <Label>Passport Expiry Date</Label>
                      <input type="date" className="form-control" {...register("passportExpiryDate")} min={moment().format("YYYY-MM-DD")} />
                  </FormGroup>
               </Col>
               <Col md={4}>
                   <FormGroup>
                       <Label>Visa Type</Label>
                       <select className="form-control" {...register("visaType")}>
                           <option value="">- Select Visa Type -</option>
                           {allVisaTypes.map(v => <option key={v.id} value={v.name}>{v.name}</option>)}
                       </select>
                   </FormGroup>
               </Col>
               <Col md={4}>
                  <FormGroup>
                      <Label>Visa Issue Date</Label>
                      <input type="date" className="form-control" {...register("visaIssueDate")} max={moment().format("YYYY-MM-DD")} />
                  </FormGroup>
               </Col>
               <Col md={4}>
                  <FormGroup>
                      <Label>Visa Expiry Date</Label>
                      <input type="date" className="form-control" {...register("visaExpiryDate")} min={moment().format("YYYY-MM-DD")} />
                  </FormGroup>
               </Col>
            </Row>

            {/* === HEALTH INSURANCE === */}
            <h5 className="mb-3 mt-4 section-header" style={{ color: '#224289', borderBottom: '1px solid #e9ebf2', paddingBottom: '10px' }}>Health Insurance</h5>
            <Row>
                <Col md={4}>
                    <FormGroup>
                        <Label>Insurance Provider</Label>
                        <select className="form-control" {...register("insuranceProvider")}>
                            <option value="">- Select Provider -</option>
                            {allInsuranceProviders.map(p => <option key={p.id} value={p.name}>{p.name}</option>)}
                        </select>
                    </FormGroup>
                </Col>
                <Col md={4}>
                    <FormGroup>
                        <Label>Policy Number</Label>
                        <input className="form-control" type="text" {...register("policyNumber")} />
                    </FormGroup>
                </Col>
                <Col md={4}>
                    <FormGroup>
                        <Label>Cover Type</Label>
                        <select className="form-control" {...register("insuranceType")}>
                            <option value="">- Select Type -</option>
                            {allInsuranceTypes.map(t => <option key={t.id} value={t.name}>{t.name}</option>)}
                        </select>
                    </FormGroup>
                </Col>
                <Col md={6}>
                    <FormGroup>
                        <Label>Cover Start Date</Label>
                        <input type="date" className="form-control" {...register("insuranceIssueDate")} />
                    </FormGroup>
                </Col>
                <Col md={6}>
                    <FormGroup>
                        <Label>Cover Expiry Date</Label>
                        <input type="date" className="form-control" {...register("insuranceExpiryDate")} />
                    </FormGroup>
                </Col>
            </Row>

           {/* === AGENT === */}
            <h5 className="mb-3 mt-4 section-header" style={{ color: '#224289', borderBottom: '1px solid #e9ebf2', paddingBottom: '10px' }}>Agent</h5>
            <Row>
                <Col md={4}>
                    <FormGroup>
                        <Label>Super Agent</Label>
                        <select className="form-control" {...register("superAgentId")}>
                            <option value="">- Select Super Agent -</option>
                             {allSuperAgents.map(a => <option key={a.id} value={a.id}>{a.name}</option>)}
                        </select>
                    </FormGroup>
                </Col>
            </Row>

            {/* === OTHERS === */}
            <h5 className="mb-3 mt-4 section-header" style={{ color: '#224289', borderBottom: '1px solid #e9ebf2', paddingBottom: '10px' }}>Others</h5>
            <Row>
                <Col md={3}>
                    <FormGroup>
                        <Label>USI</Label>
                        <input className="form-control" type="text" {...register("usi")} />
                    </FormGroup>
                </Col>
                <Col md={3}>
                    <FormGroup>
                        <Label>Membership Number</Label>
                        <input className="form-control" type="text" {...register("membershipNumber")} />
                    </FormGroup>
                </Col>
                <Col md={3}>
                    <FormGroup>
                        <Label>Membership Expiry</Label>
                        <input type="date" className="form-control" {...register("membershipExpiry")} />
                    </FormGroup>
                </Col>
                 
            </Row>
            <Row>
                <Col md={3}>
                    <FormGroup>
                        <Label>Institution Name</Label>
                        <input className="form-control" type="text" {...register("currentlyStudyingInstitutionName")} />
                    </FormGroup>
                </Col>
                <Col md={3}>
                    <FormGroup>
                        <Label>Intake</Label>
                         <input type="date" className="form-control" {...register("intake")} />
                    </FormGroup>
                </Col>
                <Col md={3}>
                    <FormGroup>
                        <Label>Status</Label>
                        <select className="form-control" {...register("status")}>
                            <option value="1">Active</option>
                            <option value="0">Inactive</option>
                        </select>
                    </FormGroup>
                </Col>
                 <Col md={3}>
                    <FormGroup>
                        <Label>Comment</Label>
                        <textarea className="form-control" rows="2" {...register("comment")}></textarea>
                    </FormGroup>
                </Col>
            </Row>

            {/* === EMERGENCY CONTACT === */}
            <h5 className="mb-3 mt-4 section-header" style={{ color: '#224289', borderBottom: '1px solid #e9ebf2', paddingBottom: '10px' }}>Client Emergency Contact Details</h5>
            <Row>
                <Col md={3}>
                    <FormGroup>
                        <Label>Name</Label>
                        <input className="form-control" type="text" {...register("clientRelativeName")} />
                    </FormGroup>
                </Col>
                <Col md={3}>
                    <FormGroup>
                        <Label>Relationship</Label>
                        <input className="form-control" type="text" {...register("clientRelation")} />
                    </FormGroup>
                </Col>
                <Col md={3}>
                    <FormGroup>
                        <Label>Email</Label>
                        <input className="form-control" type="email" {...register("clientRelativeEmail")} />
                    </FormGroup>
                </Col>
                <Col md={3}>
                    <FormGroup>
                        <Label>Phone</Label>
                        <input className="form-control" type="number" {...register("clientRelativePhone")} />
                    </FormGroup>
                </Col>
            </Row>

            <Row className="mt-5">
              <Col className="d-flex justify-content-end">
                <Button type="submit" color="primary" size="lg" style={{ minWidth: '250px', fontWeight: 'bold' }}>
                  Convert to Client
                </Button>
              </Col>
            </Row>
          </Form>
        </Card>
      </div>
    </div>
  );
};

export default CreateClientLead;
